<template>
  <div
    class="grid w-full gap-4"
    :class="{ '!grid-cols-3 flex-wrap': wrap }"
    :style="`grid-template-columns:repeat(${numberPerLine ? numberPerLine : number},minmax(0,1fr))`"
  >
    <div
      v-for="i in number"
      :key="`skeleton-product-card-${i}`"
      class="flex animate-pulse flex-col self-stretch rounded-md shadow-lg hover:shadow-2xl"
      :style="{ height }"
    >
      <div class="relative h-1/2 border border-neutral-100 bg-gray-200" />
      <div
        v-if="showColors"
        class="p-4 pb-0.5"
      >
        <div class="flex max-w-sm pb-5">
          <div
            v-for="color in 3"
            :key="color"
            class="mr-2 size-8 rounded-full bg-gray-200"
          />
        </div>
      </div>
      <div class="mx-4 mb-4 mt-auto h-[30%]">
        <div class="mb-4 h-2/5 w-2/3 rounded bg-gray-200" />
        <div class="h-2/5 rounded bg-gray-200" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  number?: number;
  numberPerLine?: number;
  showColors?: boolean;
  height?: string;
  wrap?: boolean;
}

withDefaults(defineProps<Props>(), {
  number: 6,
  showColors: true,
  height: '430px',
  wrap: false,
});
</script>
